// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const OnboardingPlaybackAccessibility = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.125 12a8.875 8.875 0 1 1 17.75 0 8.875 8.875 0 0 1-17.75 0ZM12 2.125c-5.454 0-9.875 4.421-9.875 9.875S6.546 21.875 12 21.875s9.875-4.421 9.875-9.875S17.454 2.125 12 2.125Zm2.49 4.884c0 .555-.184 1.073-.498 1.491h1.832c.577 0 1.165.262 1.514.801a1.72 1.72 0 0 1 .011 1.864l-.006.011a1.8 1.8 0 0 1-1.519.824h-1.431l.008 1.316 1.038 3.968.009.037c.22.991-.436 1.927-1.382 2.138a1.716 1.716 0 0 1-.402.041h-.01c-.666 0-1.377-.37-1.677-1.066a1.805 1.805 0 0 1-1.658 1.066h-.003c-.024 0-.15.002-.286-.026a1.18 1.18 0 0 1-.285-.096 1.825 1.825 0 0 1-1.211-2.127L9.57 13.3l.009-1.315H8.148c-.582 0-1.178-.28-1.519-.85a1.758 1.758 0 0 1-.005-1.79c.34-.589.961-.844 1.524-.844h1.869a2.517 2.517 0 0 1-.508-1.51A2.496 2.496 0 0 1 12 4.5c1.404 0 2.49 1.171 2.49 2.51Zm-1 0c0 .81-.662 1.491-1.49 1.491s-1.49-.7-1.49-1.51c0-.809.662-1.49 1.49-1.49s1.49.7 1.49 1.51ZM8.149 9.5h7.676c.283 0 .535.126.676.347a.72.72 0 0 1 0 .79.8.8 0 0 1-.676.363h-2.438l.016 2.447 1.07 4.09a.803.803 0 0 1-.63.947c-.063.016-.126.016-.189.016-.377 0-.723-.237-.802-.6l-.802-3.347a.072.072 0 0 0-.141 0l-.803 3.347v.016a.807.807 0 0 1-.786.584c-.063 0-.126 0-.173-.047a.826.826 0 0 1-.645-.948l1.07-4.073.015-2.448H8.148a.757.757 0 0 1-.66-.363.758.758 0 0 1 0-.774c.126-.22.377-.347.66-.347Z"
			fill="url(#OnboardingPlaybackAccessibility_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="OnboardingPlaybackAccessibility_tsx__a"
				x1={2.125}
				y1={2.125}
				x2={21.875}
				y2={21.875}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B275F0" />
				<stop offset={1} stopColor="#F0758A" />
			</linearGradient>
		</defs>
	</svg>
);
export default OnboardingPlaybackAccessibility;
